import { Icon } from "./icons";
import Logo from "./Logo";
import { scrollToTop } from "./scroll";
import { SOCIAL_PATHS } from "./socialIcons";

const SITE = "https://www.traxccel.com";

type FooterLink = { label: string; href: string };

/** Link destinations come from the previous footer; the industry links go to the dedicated pages on traxccel.com. */
const COLUMNS: { title: string; links: FooterLink[] }[] = [
  {
    title: "Company",
    links: [
      { label: "About us", href: `${SITE}/about` },
      { label: "Partners", href: `${SITE}/partners` },
      { label: "Join us", href: `${SITE}/join-us` },
    ],
  },
  {
    title: "Industries",
    links: [
      { label: "Oil & gas", href: `${SITE}/industries/oil-gas` },
      { label: "Manufacturing", href: `${SITE}/industries/manufacturing` },
      { label: "Distribution & logistics", href: `${SITE}/industries/distribution-and-logistics` },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Insights", href: `${SITE}/insights` },
      { label: "Experiences", href: `${SITE}/experiences` },
    ],
  },
];

/**
 * Social profiles. LinkedIn, X and Facebook are the accounts the previous footer linked to. Instagram and YouTube
 * have no known address yet: an icon with an empty url is not shown, so there is never a dead link. Add the
 * address here and the icon appears.
 */
const SOCIALS = [
  {
    key: "linkedin",
    label: "LinkedIn",
    url: "https://www.linkedin.com/company/traxccel/?viewAsMember=true",
    size: 18,
  },
  { key: "x", label: "X", url: "https://x.com/traxccel?s=09", size: 15 },
  { key: "instagram", label: "Instagram", url: "", size: 17 },
  { key: "youtube", label: "YouTube", url: "", size: 18 },
  {
    key: "facebook",
    label: "Facebook",
    url: "https://www.facebook.com/profile.php?id=100077089835520&mibextid=ZbWKwL",
    size: 17,
  },
];

export default function LandingFooter() {
  return (
    <footer className="rl-footer">
      <div className="rl-footer__in">
        <div className="rl-footer__top">
          <div className="rl-footer__brand">
            <Logo />
            <div>
              <span className="rl-fk">Follow us</span>
              <div className="rl-socs">
                {SOCIALS.filter((s) => s.url).map((s) => (
                  <a
                    key={s.key}
                    href={s.url}
                    className="rl-soc"
                    aria-label={`Traxccel on ${s.label}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg width={s.size} height={s.size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d={SOCIAL_PATHS[s.key]} />
                    </svg>
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="rl-cols">
            {COLUMNS.map((col) => (
              <nav key={col.title} className="rl-fcol" aria-label={col.title}>
                <span className="rl-fk">{col.title}</span>
                {col.links.map((l) => (
                  <a key={l.label} href={l.href} target="_blank" rel="noopener noreferrer">
                    {l.label}
                  </a>
                ))}
              </nav>
            ))}
          </div>
        </div>

        <div className="rl-footer__bot">
          <span>&copy; {new Date().getFullYear()} Traxccel. All rights reserved.</span>
          <nav aria-label="Legal">
            <a href={`${SITE}/privacy-policy`} target="_blank" rel="noopener noreferrer">
              Privacy policy
            </a>
            <a href={`${SITE}/terms-of-service`} target="_blank" rel="noopener noreferrer">
              Terms of service
            </a>
            <a
              className="rl-up"
              href="#top"
              onClick={(e) => {
                e.preventDefault();
                scrollToTop();
              }}
            >
              Back to top <Icon name="up" />
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
